export const CHAT_SUGGESTIONS = [
  "What are my top 10 departments last month?",
  "What hours of the day were we busiest last month?",
  "What was my revenue last month?",
  "How much revenue did i make each day last month?",
  "What products are trending down? ",
];
